<template>
  <div class="videoInfo">
    <div class="thumb" @click.prevent="$emit('videoSelected', videoInfo.id)">
      <img :src="videoInfo.thumbnail" :alt="getVideoTitle" />
    </div>
    <div class="content">
      <!-- <p v-text="videoInfo.name"></p> -->
      <p v-text="`${$t('label.featured')}: ${getVideoTitle}`"></p>
    </div>
  </div>
</template>
<script>
import { get } from "lodash";
export default {
  props: ["videoInfo"],

  computed: {
    locale() {
      return this.$i18n.locale;
    },
    getVideoTitle() {
      return get(this.videoInfo, `${this.locale}.title`);
    },
  },
};
</script>
<style lang="scss">
.videoInfo {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .thumb {
    cursor: pointer;
    flex: 1 1;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .content {
    flex: 1 1;
    text-align: left;
    padding: 10px;
    background: #fff;
    p {
      word-break: break-all;
      margin-bottom: 0;
      // &:first-child {
      //   font-weight: 700;
      //   text-transform: uppercase;
      // }
    }
  }
  @media (max-width: 768px) {
    .content {
      padding: 5px;
    }
  }
}
</style>
